import { Component, HostListener } from '@angular/core';
import { LoginService } from './components/login/service/login.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
 
    dateTime!: Date;
    userDetails:any;
  constructor(private service:LoginService,private router:Router){}
 
  ngOnInit(){
    if(sessionStorage.getItem("token") && localStorage.getItem("user")){
        // this.getUser();
        let response:any = localStorage.getItem("user");
        this.service.isAuthorizedUser=true;
        var data = CryptoJS.AES.decrypt(response,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
                 this.userDetails = JSON.parse(data);
                 this.service.userDetails = JSON.parse(data);
                     this.service.userDetails = response;
                      if(!this.userDetails.hasOwnProperty("plan_id")){
                         // this.router.navigate(['/main/settings']);
                          return;
                      }
                    if (new Date(this.userDetails?.end_date).getTime() < new Date(this.dateTime).getTime() && this.userDetails?.plan_id === 1) {
                       //this.router.navigate(['/main/settings']);
                    } else {
                      // this.router.navigate(['/main']);
                    }
     }

    //document.body.oncontextmenu = function () { return false; }
  }



  @HostListener('window:popstate', ['$event'])
  onPopState(event?: any) {
    const url = window.location.pathname;
    if (url === '/login') {
      event.preventDefault();
       if (this.service.isAuthorizedUser) {
        history.go(1);
      }
    }
  
  }


  getUser(){
      this.service.getUser().subscribe({
        next:(response:any)=>{
          if(response.hasOwnProperty("userid")){
            this.service.isAuthorizedUser = true;
              this.userDetails = response;
                    var data = CryptoJS.AES.encrypt(JSON.stringify(response),this.service.enCryptKey);
                      localStorage.setItem("user",data.toString());
                     this.service.userDetails = response;
                      if(!this.userDetails.hasOwnProperty("plan_id")){
                          this.router.navigate(['/dashboard']);
                          return;
                      }
                    if (new Date(this.userDetails?.end_date).getTime() < new Date(this.dateTime).getTime() && this.userDetails?.plan_id === 1) {
                       this.router.navigate(['/dashboard']);
                    } else {
                       this.router.navigate(['/dashboard']);
                    }
           // this.router.navigateByUrl("main");
          }else{
             localStorage.clear();
            this.router.navigateByUrl("login");
          }
              
        },
        error:(error:HttpErrorResponse)=>{
           localStorage.clear();
          this.router.navigateByUrl("login");
        }
      });
    }
}
